import { render, staticRenderFns } from "./Terminal.vue?vue&type=template&id=5f4c61b2&scoped=true&"
import script from "./Terminal.vue?vue&type=script&lang=ts&"
export * from "./Terminal.vue?vue&type=script&lang=ts&"
import style0 from "./Terminal.vue?vue&type=style&index=0&id=5f4c61b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4c61b2",
  null
  
)

export default component.exports